import { getPOSCache, savePOSCache } from "@/lib/offlineQueue";

// Display metadata only. No cookies, credentials, queue records or server grants.
const key = (actorId, kind) => `workspace-display:v1:${actorId}:${kind}`;
export const canUseOfflineWorkspace = (user, path) => !!user?.id &&
  ["staff", "cashier", "outlet", "outlet_manager"].includes(user.role) &&
  (path === "/pos" || path.startsWith("/pos/"));

export const saveWorkspaceDisplay = async (actorId, kind, value) => {
  if (!actorId) return;
  const display = kind === "outlets" ? value.map(({ id, name, code, is_central_kitchen, is_active }) =>
    ({ id, name, code, is_central_kitchen, is_active })) : {
    central_kitchen: value.central_kitchen === true, management: value.management === true,
    all_outlets: value.all_outlets === true, outlet_ids: value.outlet_ids || [],
  };
  await savePOSCache(key(actorId, kind), { schema_version: 1, actor_id: actorId, value: display });
};

export const readWorkspaceDisplay = async (actorId, kind) => {
  if (!actorId) return null;
  const cached = await getPOSCache(key(actorId, kind));
  return cached?.schema_version === 1 && cached.actor_id === actorId ? cached.value : null;
};

export const clearWorkspaceDisplay = async actorId => {
  if (actorId) await Promise.all(["access", "outlets"].map(kind => savePOSCache(key(actorId, kind), null)));
};